module.exports = __webpack_public_path__ + "img/exam_video.efd9bfeb.png";